import { TextAlignment } from '@tink/config/src/tinkLinkConfig';
import { ReactNode } from 'react';
import { useConfiguration } from '../ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { Stack as StackImport, StackProps } from '../atoms/Stack/Stack';

type ContentAlignmentContainerProps = {
  children: ReactNode;
  Stack?: React.ComponentType<StackProps>;
};

const getAlignmentFromTheme = (textAlignment: TextAlignment) =>
  textAlignment === TextAlignment.CENTER ? 'center' : 'start';

export const ContentAlignmentContainer = ({
  children,
  Stack = StackImport,
}: ContentAlignmentContainerProps) => {
  const { activeTheme } = useConfiguration();

  return <Stack alignItems={getAlignmentFromTheme(activeTheme.textAlignment)}>{children}</Stack>;
};
